import _ from 'lodash';

export function courseBuilderConstants(t) {
  return {

    'TAB_RUNNING_ID': 'running',
    'TAB_TRI_CYCLE_SWIM_ID': 'tri-cycle-swim',
    'TAB_BUILD_YOUR_OWN_ID': 'build-your-own',

    'STANDARD_COURSES': {
      'running': [
        {
          groupTitle: t('Most common'),
          items: [
            {cpid:  13, label: t('5K Run')},
            {cpid:   6, label: t('10K Run')},
            {cpid:  17, label: t('Marathon')},
            {cpid: 467, label: t('Half Marathon')},
            {cpid: 578, label: t('8K Run')},
            {cpid: 572, label: t('15K Run')},
            {cpid: 579, label: t('25K Run')},
            {cpid: 561, label: t('50K Run')},
            {cpid: 236, label: t('50 Mile Run')},
            {cpid: 557, label: t('3K Run')},
            {cpid: 559, label: t('4 Mile Run')},
            {cpid: 556, label: t('5 Mile Run')},
            {cpid: 422, label: t('10 Mile Run')}
          ]
        }, {
          groupTitle: t('Trail Runs'),
          items: [
            {cpid: 617, label: t('5K Trail Run')},
            {cpid:  21, label: t('10K Trail Run')},
            {cpid: 623, label: t('25K Trail Run')},
            {cpid: 640, label: t('Trail Marathon')},
            {cpid: 639, label: t('50 Mile Trail Run')},
            {cpid: 622, label: t('50K Trail Run')}
          ]
        }, {
          groupTitle: t('Track and Field'),
          items: [
            {cpid: 1038, label: t('100M Run')},
            {cpid:  594, label: t('200M Run')},
            {cpid:  601, label: t('400M Run')},
            {cpid:  681, label: t('800M Run')},
            {cpid:  649, label: t('1500M Run')},
            {cpid:  558, label: t('1 Mile Run')}
          ]
        }
      ],

      'tri-cycle-swim': [
        {
          groupTitle: t('Triathlon & Multisport'),
          items: [
            {cpid: 884, label: t('Sprint Tri (400M Swim, 20K Bike, 5K Run)')},
            {cpid: 320, label: t('Sprint Tri (800M Swim, 20K Bike, 5K Run)')},
            {cpid: 758, label: t('Sprint Tri (500M Swim, 20K Bike, 5K Run)')},
            {cpid: 182, label: t('Sprint Tri (750M Swim, 20K Bike, 5K Run)')},
            {cpid:  12, label: t('Olympic Tri (1500M Swim, 40K Bike, 10K Run)')},
            {cpid:  41, label: t('Half Ironman Triathlon')},
            {cpid:  24, label: t('Ironman Triathlon')}
          ]
        },
        {
          groupTitle: t('Cycling'), items: [
          {cpid: 2643, label: t('20K Time Trial')},
          {cpid: 2685, label: t('40K Time Trial')},
          {cpid: 1787, label: t('100 Mile (Century)')},
          {cpid: 1803, label: t('100K (Metric Century)')}
        ]
        },
        {
          groupTitle: t('Swimming'), items: [
          {cpid: 2209, label: t('50M Swim')},
          {cpid: 2207, label: t('100M Swim')},
          {cpid: 2208, label: t('200M Swim')},
          {cpid: 2210, label: t('400M Swim')},
          {cpid: 2434, label: t('500M Swim')},
          {cpid: 1192, label: t('800M Swim')},
          {cpid: 1354, label: t('½ Mile Swim')},
          {cpid:   15, label: t('1500M Swim')},
          {cpid:   20, label: t('1 Mile Swim')},
          {cpid: 1198, label: t('1.2 Mile Swim')},
          {cpid: 2072, label: t('1.5 Mile Swim')},
          {cpid:   19, label: t('2 Mile Swim')},
          {cpid: 1407, label: t('2.4 Mile Swim')},
          {cpid:  552, label: t('1K Swim')},
          {cpid: 2047, label: t('2K Swim')},
          {cpid:   49, label: t('5K Swim')}
        ]
        }
      ]
    },

    /** Race categories for Build Your Own tab */
    'BYO_RACE_CATEGORIES': [
      {raceCatId: 12, isMulti: false, caption: t('Adventure Race')},
      {raceCatId: 22, isMulti: true,  caption: t('Aquabike')},
      {raceCatId: 21, isMulti: true,  caption: t('Aquathlon')},
      {raceCatId: 20, isMulti: false, caption: t('Canoe/Kayak')},
      {raceCatId: 30, isMulti: false, caption: t('Criterium')},
      {raceCatId:  3, isMulti: false, caption: t('Cycling')},
      {raceCatId: 29, isMulti: false, caption: t('Cyclocross')},
      {raceCatId:  8, isMulti: true,  caption: t('Duathlon')},
      {raceCatId:  4, isMulti: false, caption: t('Inline Skate')},
      {raceCatId: 10, isMulti: false, caption: t('Mountain Bike')},
      {raceCatId: 11, isMulti: false, caption: t('Mountain Climb')},
      {raceCatId: 32, isMulti: false, caption: t('Obstacle')},
      {raceCatId: 25, isMulti: true,  caption: t('Off-Road Aquabike')},
      {raceCatId: 24, isMulti: true,  caption: t('Off-Road Duathlon')},
      {raceCatId: 23, isMulti: true,  caption: t('Off-Road Triathlon')},
      {raceCatId: 26, isMulti: true,  caption: t('Paddle Triathlon')},
      {raceCatId: 18, isMulti: false, caption: t('Paddleboard')},
      {raceCatId: 17, isMulti: false, caption: t('Race Walk')},
      {raceCatId: 27, isMulti: false, caption: t('Stair Climb')},
      {raceCatId: 28, isMulti: false, caption: t('Orienteering')},
      {raceCatId:  2, isMulti: false, caption: t('Run')},
      {raceCatId:  5, isMulti: false, caption: t('Cross Country Ski')},
      {raceCatId: 19, isMulti: false, caption: t('Snowshoe Run')},
      {raceCatId: 16, isMulti: false, caption: t('Swim')},
      {raceCatId: 15, isMulti: false, caption: t('Trail Run')},
      {raceCatId:  7, isMulti: true,  caption: t('Triathlon')},
      {raceCatId:  6, isMulti: false, caption: t('Wheelchair Race')}
    ],

    'BYO_LEG_DISTANCES': [
      {val: 7, caption: t('Kilometer'), dist: 'K'},
      {val: 6, caption: t('Meter'), dist: 'M'},
      {val: 1, caption: t('Mile'), dist: ' Mi'},
      {val: 4, caption: t('Yard'), dist: ' Yd'}
    ],

    'BYO_ACTION_CATEGORIES': [
      {val:  4, caption: t('Bike')},
      {val: 11, caption: t('Canoe')},
      {val:  8, caption: t('Climb/Repel')},
      {val:  9, caption: t('Hike')},
      {val:  7, caption: t('Inline Skate')},
      {val:  5, caption: t('Mountain Bike')},
      {val:  6, caption: t('Navigate')},
      {val: 12, caption: t('Paddleboard')},
      {val:  1, caption: t('Run')},
      {val: 14, caption: t('Snowshoe Run')},
      {val: 15, caption: t('Stair Climb')},
      {val:  3, caption: t('Swim')},
      {val:  2, caption: t('Trail Run')},
      {val: 10, caption: t('Walk')},
      {val: 13, caption: t('XC Ski')}
    ],

    /**
     Race category to action category map
     Used for single sport custom courses
     */
    // TODO: Check if all single sports are here. Looks
    'RACE_CAT_TO_ACTION_CAT_MAP': {
      2: 1,
      3: 4,
      4: 7,
      5: 13,
      6: 18, /* Wheelchair -> Other */
      11: 8,
      15: 2,
      16: 3,
      17: 10,
      18: 12,
      19: 14,
      20: 11,
      27: 15,
      29: 5,
      30: 4,
      10: 5,
      32: 17
    }
  };
};

export function getByoForRaceCatId(t, raceCatId) {
  const info = getRaceCatInfo(t, raceCatId);

  if (!info) {
    throw 'Unable to find race category with ID: \'' + action.raceCatId + '\'';
  }

  const byo = {
    raceCat: info,
    legs:  getDefaultLegs(t, raceCatId)
  };

  return {
    ...byo,
    courseName: buildByoCourseName(t, byo)
  }
}

export function buildByoCourseName(t, byo) {
  if (!byo || !byo.raceCat || !byo.legs || byo.legs.length === 0) {
    return '';
  }

  if (!byo.raceCat.isMulti){
    const leg0 = byo.legs[0];

    if (!leg0.dist)
      return '';

    const leg0distInfo = getDistKindInfo(t, leg0.distKind);

    return Number(leg0.dist) + leg0distInfo.dist + ' ' + byo.raceCat.caption;
  }

  const name = byo.raceCat.caption + ': ';

  const legs =(byo.legs).reduce((res, leg) => {
    if (!leg.dist || leg.actionCat < 1)
      return res;

    const ac = getActionCatInfo(t, leg.actionCat);
    const d = getDistKindInfo(t, leg.distKind);
    const legDesc = Number(leg.dist) + d.dist + ' ' + ac.caption;

    if (res !== '')
      res += ', ';

    return res + legDesc;
  }, '');

  return name + legs;
}

/** Gets default leg or legs info for given race category */
function getDefaultLegs(t, raceCatId) {
  if (raceCatId === 7 /* Triathlon: Swim, Bike, Run */){
    return [
      { dist: '', distKind: 7, actionCat: 3 },
      { dist: '', distKind: 7, actionCat: 4 },
      { dist: '', distKind: 7, actionCat: 1 }
    ];
  }

  const rcInfo = getRaceCatInfo(t, raceCatId);

  if (rcInfo && rcInfo.isMulti){
    return [
      { dist: '', distKind: 7, actionCat: 0 },
      { dist: '', distKind: 7, actionCat: 0 },
      { dist: '', distKind: 7, actionCat: 0 }
    ];
  }

  return [{ dist: '', distKind: 7, actionCat: null}];
}

function getRaceCatInfo(t, raceCatId) {
  return _.find(courseBuilderConstants(t).BYO_RACE_CATEGORIES, function(rc){
    return rc.raceCatId === raceCatId;
  });
}

function getActionCatInfo(t, actionCatId) {
  return _.find(courseBuilderConstants(t).BYO_ACTION_CATEGORIES, function(ac){
    return ac.val === actionCatId;
  });
}

function getDistKindInfo(t, distKindId){
  return _.find(courseBuilderConstants(t).BYO_LEG_DISTANCES, function(dc){
    return dc.val === distKindId;
  });
}



/** WEBPACK FOOTER **
 ** ./utils/races/CourseBuilderConstants.js
 **/